/** The minimal shape this constraint reads: only `mode` drives whether the field is mandatory. */
type CreationModeShape = {
	readonly mode: 'create' | 'version';
};

/**
 * Generic over the minimal shape it reads, not over `DocumentTemplateUploadFormData` itself, so the
 * FormData never has to import its own constraint back (`guides/forms.md` §1.1). `name` and
 * `documentTypeId` share this one constraint: a new version carries neither field — only `file` does.
 * `value` covers both a string field (`name`, empty string means unfilled) and a numeric selection
 * (`documentTypeId`, `null` means unfilled).
 */
function isFilledWhenCreating<T extends CreationModeShape>(
	value: string | number | null,
	formData: T,
): boolean {
	if (formData.mode !== 'create') {
		return true;
	}

	return value !== '' && value !== null;
}

export default isFilledWhenCreating;
